import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import md5 from 'md5/md5';
import { LoginService } from '../../service/loginService';

function LoginRouting(props) {

  const {
    ValidarAcessoToken
  } = props;

  const toast = useRef(null);
  const [Login, setLogin] = useState(null);
  const [Senha, setSenha] = useState(null);
  const [Progress, setProgress] = useState(false);
  const [msgErro, setMsgErro] = useState("");
  const [infoAlert, setInfoAlert] = useState("");

  useEffect(() => {
    if (msgErro) {
      erroLogin(msgErro);
      setProgress(false);
    }
  }, [msgErro])


  const gerarNonce = () => {
    return (Math.random(new Date().getUTCMilliseconds())).toString().replace('.', '');
  };

  const gerarMD5 = (Usuario, Senha, Nonce) => {
    return md5(Usuario + Nonce + Senha)
  };

  const showAlert = (title, msg, backgroundColor, time) => {
    setInfoAlert(<div style={{ display: 'flex', color: 'white', marginTop: '10px', background: backgroundColor, padding: '5px 10px 5px 10px', borderRadius: '5px' }}>
      <div style={{ width: '100%' }}><b>{title}</b> {msg}</div>
      <Button label='' icon='pi pi-times-circle' className='p-button-text p-button-sm p-button-danger' onClick={() => setInfoAlert("")} />
    </div>);
    if (time) {
      setTimeout(() => {
        setInfoAlert("");
      }, time);
    }
  }

  const validarCampos = () => {
    if (Login === "" || Login === null) {
      showAlert('Atenção!', 'Digite seu login de usuário.', 'indianred', 5000);
      return document.getElementById("login").focus();
    }
    if (Senha === "" || Senha === null) {
      showAlert('Atenção!', 'Digite sua senha.', 'indianred', 5000);
      return document.getElementById("senha").focus();
    }
    return true;
  }

  const logar = () => {
    if (validarCampos()) {
      setProgress(true);
      const cnonce = gerarNonce();
      const loginDTO = {
        name: Login.toLowerCase(),
        cnonce: cnonce,
        md5: gerarMD5(Login.toLowerCase(), Senha.toLowerCase(), cnonce)
      }
      ValidarAcessoToken({ LoginDTO: loginDTO, SetMsgErro: setMsgErro });
    }
  }

  const lembrarSenha = () => {
    if (Login === "" || Login === null) {
      document.getElementById('login').focus();
      return alert('Informe o login de usuário');
    }
    setProgress(true);
    const _loginService = new LoginService();
    _loginService.lembrarSenha(Login)
      .then(resp => {
        setProgress(false);
        if (resp['data']) {
          showAlert('Sucesso!', 'Senha enviada com sucesso!', 'green', 10000);
          return;
        }
        showAlert('Falha.', 'Falha ao lembrar senha. Contate o administrador.', 'indianred', 0);
      })
      .catch(error => {
        console.log(error);
        setProgress(false);
        showAlert('Falha.', 'Falha ao lembrar senha. Contate o administrador.', 'indianred', 0);
      })
  }

  const erroLogin = (error) => {
    setProgress(false);
    showAlert('Acesso negado!', error, 'indianred', 0);
    setMsgErro("");
  }

  const senhaOnEnter = (e) => {
    if (e.keyCode === 13)
      logar();
  }

  const header = <div style={{ textAlign: "center", fontSize: "22px", fontWeight: "500" }}>
    <img src={`assets/logo-web-viewer.png`} style={{ height: '40px' }} />
  </div>;

  const footer = <div style={{ textAlign: "center" }}>
    <div style={{ fontSize: "12px", color: "#818181" }}>
      {window.config.versao}
    </div>
  </div>;

  const progress = Progress ? <ProgressSpinner style={{ width: '20px', height: '20px', top: "8px" }} strokeWidth="5" animationDuration=".5s" /> : null;

  const boxLogin = () => {
    const tpl = sessionStorage.getItem('redirectMsg') ?
      <div style={{ textAlign: 'center' }}>
        <div>
          <div style={{ textAlign: "center", fontSize: "22px", fontWeight: "500", width: '100%', marginTop: '15%' }}>
            <img src={`assets/logo-web-viewer.png`} style={{ height: '40px', display: 'initial', marginBottom: '20px' }} />
            <div>Obrigado por utilizar o Tzion WebViewer!</div>
          </div>
        </div>
      </div>
      : <Card footer={footer} className="p-md-3 " style={{ padding: "20px", paddingBottom: "0", marginTop: "10vw", display: window.location.search ? 'none' : '' }}>
        <div style={{ textAlign: '-webkit-center', marginBottom: '10px' }}>
          <img src={`assets/logo-web-viewer.png`} width='183' height='50' />
        </div>
        <div className="p-fluid">
          <div className="p-field" style={{ marginBottom: '10px' }}>
            <label htmlFor="login">Login</label>
            <span className="p-input-icon-left">
              <i className="pi pi-user" />
              <InputText
                id="login"
                value={Login}
                onChange={(e) =>
                  setLogin(e.target.value)}
                placeholder="Login de usuário"
                autoFocus
              />
            </span>
          </div>
          <div className="p-field" style={{ marginBottom: '10px' }}>
            <label htmlFor="senha">Senha</label>
            <Password
              id="senha"
              toggleMask
              feedback={false}
              value={Senha}
              onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => senhaOnEnter(e)} placeholder="Senha"
            />
          </div>
          <Button
            label="Entrar"
            onClick={logar}
          />
        </div>
        <Button label={<div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
          <div style={{ textAlign: 'left' }}>{progress}</div>
          <div style={{ textAlign: 'right', width: '100%' }}>Lembrar senha</div>
        </div>}
          onClick={lembrarSenha} className="p-button-link" style={{ textAlign: "right", width: '100%', padding: '2px', marginTop: '10px' }} />
        {infoAlert}
      </Card>;

    const sessionAuth = sessionStorage.getItem('auth');
    if (sessionAuth)
      setTimeout(() => { return tpl }, 1000);
    else
      return tpl;
  }

  return (
    <div className={sessionStorage.getItem('redirectMsg') ? '' : 'boxLogin'} >
      <Toast ref={toast} position='top-right' style={{ position: 'absolute' }} />
      {boxLogin()}
    </div>
  )
}
export default LoginRouting;
